import { Controller } from "@hotwired/stimulus";

class SearchController extends Controller {
  static targets = ["form", "icon", "input", "submit", "suggestions"];
  static values = { placeholder: String };
  static cache = new Map();

  connect() {
    if (this.hasInputTarget) {
      this.inputTarget.addEventListener("focus", this.handleFocus.bind(this));
      this.inputTarget.addEventListener("blur", this.handleBlur.bind(this));
    }
    document.addEventListener("click", this.#handleClickOutside);
  }

  disconnect() {
    if (this.hasInputTarget) {
      this.inputTarget.removeEventListener(
        "focus",
        this.handleFocus.bind(this),
      );
      this.inputTarget.removeEventListener("blur", this.handleBlur.bind(this));
    }
    document.removeEventListener("click", this.#handleClickOutside);
  }

  handleFocus() {
    this.toggleClasses();
    this.inputTarget.placeholder = "";
  }

  handleBlur() {
    this.toggleClasses();
    this.inputTarget.placeholder = this.placeholderValue;
  }

  #handleClickOutside = (event) => {
    if (!this.hasSuggestionsTarget) {
      return;
    }

    const isHidden = this.suggestionsTarget.classList.contains("tw:hidden");

    if (isHidden) {
      return;
    }

    if (!this.element.contains(event.target)) {
      this.suggestionsTarget.classList.add("tw:hidden");
    }
  };

  toggleClasses() {
    const iconClasses = ["tw:opacity-100", "tw:opacity-0"];
    const submitClasses = [
      "tw:opacity-0",
      "tw:opacity-100",
      "tw:-translate-x-2",
    ];
    iconClasses.forEach((className) => {
      this.iconTarget.classList.toggle(className);
    });
    submitClasses.forEach((className) => {
      this.submitTarget.classList.toggle(className);
    });
    this.inputTarget.classList.toggle("tw:pl-3");
    this.formTarget.classList.toggle("tw:pl-4");
  }

  renderSearchResults(resultsMarkup) {
    this.suggestionsTarget.innerHTML = resultsMarkup;
    this.isOpen = true;
    this.suggestionsTarget.classList.remove("tw:hidden");
  }

  async getSuggestions(event) {
    const queryKey = event.target.value;

    if (!queryKey) {
      return this.suggestionsTarget.classList.add("tw:hidden");
    }

    // Try to render results from cache first
    if (SearchController.cache.has(queryKey)) {
      return this.renderSearchResults(SearchController.cache.get(queryKey));
    }

    const response = await fetch(
      `${Theme.routes.predictive_search_url}?q=${encodeURIComponent(queryKey)}&section_id=predictive-search`,
    );

    if (!response.ok) {
      const error = new Error(response.status);
      this.toggleClasses();
      throw error;
    }

    const text = await response.text();

    const resultsMarkup = new DOMParser()
      .parseFromString(text, "text/html")
      .querySelector("#shopify-section-predictive-search").innerHTML;

    SearchController.cache.set(queryKey, resultsMarkup);
    this.renderSearchResults(resultsMarkup);
  }
}

Stimulus.register("search", SearchController);
